import { render, staticRenderFns } from "./EmployeeArchivedTable.vue?vue&type=template&id=b130c7f2&scoped=true&"
import script from "./EmployeeArchivedTable.vue?vue&type=script&lang=js&"
export * from "./EmployeeArchivedTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b130c7f2",
  null
  
)

export default component.exports